// eslint-disable-next-line import/prefer-default-export
import regionConfig from '../config';

const AppName = regionConfig.appName;

export const SITE_DESCRIPTION = `${AppName} provides full video conferencing solutions to your smartphone or tablet device so you can leverage visual communication anywhere! ${AppName} is a first-class service provider of online video interpreting services through its Video Relay Service (VRS) and Video Remote Interpreting (VRI). This allows Deaf people anywhere in the world to communicate with anyone, at any time, using an app which connects them to a qualified British Sign Language Interpreter.`;
export const SITE_TITLE = AppName;
export const BUSINESS_DIRECTORY_TITLE = `Community Directory`;
export const BUSINESS_DIRECTORY_DESCRIPTION_PREFIX = `${AppName} Customer Community Directory`;
export const VIDEO_MAIL_PAGE_DESCRIPTION_PREFIX = `${AppName} Customer Videomail`;
export const VIDEO_MAIL_PAGE_TITLE = 'Customer Videomail';
export const USAGE_PAGE_TITLE = 'Customer Usage';

export const USAGE_PAGE_DESCRIPTION_PREFIX = `${AppName} Customer Usage`;
